import * as React from 'react'
import './contact-us.css'
import { ComponentState } from 'react'
import { GearIcon } from 'src/components/Shared/gear/gear'

interface IState {
  email: string
  message: string
  phoneNumber: string
  success: boolean
  trying: boolean
  userName: string
}

export default class ContactUs extends React.Component<any, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      email: '',
      message: '',
      phoneNumber: '',
      success: false,
      trying: false,
      userName: '',
    }
    this.sendEmail = this.sendEmail.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  sendEmail = (e: any) => {
    e.preventDefault()
    const { email, message, phoneNumber, userName } = this.state
    this.setState({ trying: true })
    fetch('https://ebson-email.herokuapp.com/api/send_email', {
      body: JSON.stringify({ email, userName, phoneNumber, message }),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    }).then((response) => {
      response.json()
      this.setState({
        email: '',
        message: '',
        phoneNumber: '',
        success: true,
        trying: false,
        userName: '',
      })
      return false
    })
    return false
  }

  handleChange(e: any) {
    e.preventDefault()
    this.setState({ [e.target.name]: e.target.value } as ComponentState)
  }

  render() {
    return (
      <div className="item-container">
        <div className="contact-us-container ">
          <span className="contact-us-header">Vertu í bandi</span>
          <h2>
            Við leggjum áherslu á góða þjónustu og tökum vel á móti öllum
            fyrirspurnum
          </h2>
          {this.state.success && (
            <div>
              Takk fyrir fyrirspurnina. Við svörum þér eins fljótt og möguleiki
              er á.
            </div>
          )}
          <form onSubmit={this.sendEmail}>
            <input
              type="text"
              placeholder="Nafn"
              className="input"
              name="userName"
              value={this.state.userName}
              onChange={this.handleChange}
            />
            <input
              type="email"
              placeholder="Netfang"
              className="input"
              name="email"
              value={this.state.email}
              onChange={this.handleChange}
            />
            <input
              type="tel"
              placeholder="Símanúmer"
              className="input"
              name="phoneNumber"
              value={this.state.phoneNumber}
              onChange={this.handleChange}
            />
            <input
              type="text"
              placeholder="Skilaboð"
              className="input"
              name="message"
              value={this.state.message}
              onChange={this.handleChange}
            />
            <input type="submit" className="submit" value="Senda skilaboð" />
            {this.state.trying && <GearIcon />}
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/contact-us-page/contact-us/contact-us.tsx